<template>
  <div class="searchbar-container">
    <input 
      autocomplete="off"
      placeholder="Search for DHR, Assemblies, LOT's, ..." 
      :value="newVal"
      @input="updateField($event)"
    >
  </div>
</template>

<script>

export default {
  components: {
  },
   
  props: {
  },
  mounted() {},
  data() {
    return {
      newVal: "",
      searchTerm: "",

    };
  },
  methods: {
    updateField(event) {
      this.newVal = event.target.value
      this.searchTerm = event.target.value
      this.$emit('input', event.target.value)
    },  
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/tables.scss";
@import "@/style/components/inputs";

.searchbar-container {
  padding: 12px 24px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  background-color: $white;
  border-radius: 8px;

  input {
    height: 40px;
    border: none;
    font-size: 14px;
    font-weight: 500;
  }
}

</style>